import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="note">
      <p>{`To use private packages, you must`}</p>
      <ul>
        <li> be using npm version 2.7.0 or greater. To upgrade, on the command line, run <code className="highlighter-rouge">npm install npm@latest -g</code></li>
        <li>have a <a href="https://www.npmjs.com/pricing">paid user or organization account</a></li>
      </ul>
    </div>
    <p>{`With npm private packages, you can use the npm registry to host code that is only visible to you and chosen collaborators, allowing you to manage and use private code alongside public code in your projects.`}</p>
    <p>{`Private packages always have a scope, and scoped packages are private by default.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`User-scoped private packages`}</strong>{` can only be accessed by you and collaborators to whom you have granted read or read/write access. For more information, see "`}<a parentName="li" {...{
          "href": "adding-collaborators-to-private-packages-owned-by-a-user-account"
        }}>{`Adding collaborators to private packages owned by a user account`}</a>{`".`}</li>
      <li parentName="ul"><strong parentName="li">{`Organization-scoped private packages`}</strong>{` can only be accessed by teams that have been granted read or read/write access. For more information, see "`}<a parentName="li" {...{
          "href": "managing-team-access-to-organization-packages"
        }}>{`Managing team access to organization packages`}</a>{`".`}</li>
    </ul>
    <h2>{`Next steps`}</h2>
    <ul>
      <li parentName="ul">{`"`}<a parentName="li" {...{
          "href": "creating-and-publishing-private-packages"
        }}>{`Creating and publishing private packages`}</a>{`"`}</li>
      <li parentName="ul">{`"`}<a parentName="li" {...{
          "href": "using-npm-packages-in-your-projects"
        }}>{`Using npm packages in your projects`}</a>{`"`}</li>
    </ul>
    <h2>{`Resources`}</h2>
    <iframe src="https://www.youtube.com/embed/O6JoXGnHK_Y" frameBorder="0" allowFullScreen></iframe>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      